import { createAsyncThunk } from "@reduxjs/toolkit";
import { axiosApiInstance } from "@/lib/axios";
import { API_PORTAL_URL } from "@/lib/config";

export const getAllActiveTours = createAsyncThunk(
  "Tour/FindAllActiveTour",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_PORTAL_URL}/Tour/FindAllActiveTour`,
      );
      return response.data?.Data;
    } catch (error: any) {
      console.error("Error Fetching tours:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

// export const getPackageByURL = createAsyncThunk(
//   "Package/FindByURLPackage",
//   async (URL: string) => {
//     try {
//       const response = await axiosApiInstance.post(
//         `${API_PORTAL_URL}/Package/FindByURLPackage`,
//         { URL },
//       );
//       return response.data?.Data;
//     } catch (error: unknown) {
//       const err = error as { response?: { data?: { Details?: string } } };
//       console.error("Error Fetching Package:", error);
//       return Promise.reject({
//         message: err?.response?.data?.Details || "Something went wrong",
//       });
//     }
//   },
// );

export const insertPackageInquiry = createAsyncThunk(
  "Website/InsertPackageInquiry",
  async (formdata: unknown) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_PORTAL_URL}/Website/InsertWebsiteInquiry`,
        formdata,
      );
      return response.data?.Data;
    } catch (error: unknown) {
      const err = error as { response?: { data?: { Details?: string } } };
      console.error("Error inserting package inquiry:", error);
      return Promise.reject({
        message: err?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

// ─── Server-side fetch functions ─────────────────────────────────────────────

export async function fetchAllActiveSOUPackage() {
  try {
    const res = await fetch(
      `${API_PORTAL_URL}/SOUPackage/FindAllActiveSOUPackage`,
      {
        method: "GET",
        headers: { "Content-Type": "application/json" },
        next: { revalidate: 30 },
      },
    );
    const json = await res.json();
    return json.Data ?? [];
  } catch {
    return [];
  }
}

export async function fetchAllActiveTours() {
  try {
    const res = await fetch(`${API_PORTAL_URL}/Tour/FindAllActiveTour`, {
      method: "GET",
      headers: { "Content-Type": "application/json" },
      next: { revalidate: 30 },
    });
    const json = await res.json();
    return json.Data ?? [];
  } catch {
    return [];
  }
}

export async function fetchPackageByURL(URL: string) {
  try {
    const res = await fetch(`${API_PORTAL_URL}/Website/TourDetailsByURL`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ TourURL: URL }),
      next: { revalidate: 30 },
    });
    const json = await res.json();
    return json.Data ?? null;
  } catch {
    return null;
  }
}

export async function fetchSOUPackageByURL(URL: string) {
  try {
    const res = await fetch(
      `${API_PORTAL_URL}/SOUPackage/FindByURLSOUPackage`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ PackageURL: URL }),
        next: { revalidate: 30 },
      },
    );
    const json = await res.json();
    return json.Data ?? null;
  } catch {
    return null;
  }
}

export const getPackageByURLAPI = createAsyncThunk(
  "Tour/TourDetailsByURL",
  async (URL: string) => {
    try {
      const res = await axiosApiInstance.post(
        `${API_PORTAL_URL}/Website/TourDetailsByURL`,
        {
          TourURL: URL,
        },
      );
      return res.data?.Data ?? null;
    } catch (error) {
      console.error("Error fetching package by URL:", error);
      return null;
    }
  },
);
